import React from "react";

function About_Us() {
  return (
    <>

      {/* UI — EXACTLY THE SAME */}
      <div className="py-6 px-4">
        <div className="pb-4 md:pb-4 md:pt-4 px-6 pt-2 bg-white shadow-md rounded-md">
          <div>
            <h1 className="text-xl font-bold text-gray-800 tracking-wide">
              About
            </h1>

            <p className="text-base md:text-sm text-justify text-gray-600 opacity-80">
              Associate Software Engineer at U2opia Mobile, contributing to
              telecom-scale, real-time systems and helping build scalable
              backend services and high-performance user interfaces used in
              production environments.
              <br /> <br />
              I primarily work with Java, Spring Boot, React, Node.js, AWS, and
              microservices-based architectures, contributing across backend
              services, APIs, and frontend workflows. At U2opia, I’m involved in
              building and improving production systems with a focus on
              performance, reliability, and maintainability, and in developing
              reusable components that support multiple products.
              <br /> <br />
              Previously, I gained hands-on experience delivering
              production-ready full-stack applications using Vue.js, Node.js,
              and MySQL, where I worked on improving performance, reducing query
              latency, and enhancing responsiveness across platforms. I also
              have a strong foundation in UI/UX design, which helps me build
              interfaces that are both functional and user-centric.
              <br /> <br />
              I hold an Integrated MCA from Amity University, Noida (CGPA:
              9.08/10) and was awarded a Silver Medal (2nd Rank) for academic
              excellence— reflecting strong fundamentals and consistency
              alongside real-world engineering experience.
              <br /> <br />I enjoy working in Agile, collaborative teams,
              solving meaningful problems, and building scalable,
              business-aligned software systems. Open to Software Engineer /
              Full-Stack opportunities where I can contribute to high-quality
              products and continue growing as an engineer.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About_Us;
